<div mat-dialog-title style="margin:0px;">
        <div style="font-size: 20pt; color: #3F51B5;">Delete Snapshot</div>  <!-- [{{SnapshotName}}]-->
    </div>
    
    <mat-dialog-content>
        <div>This will delete the snapshot of <b>{{reportName}}</b> taken <b>{{autoRunDate|date:'MM/dd/yy
                HH:mm a'}}.</b>
            <!-- <div>This Snapshot will be deleted.</div> -->
        </div>
    </mat-dialog-content>
    
    <mat-dialog-actions>
        <div class="flex-footer-right">
            <tyl-button id="okDeleteSnapshotButton" image="save.png" label="OK" (clickEvent)="okClick()"></tyl-button>
            <tyl-button id="cancelDeleteSnapshotButton" image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
        </div>
    </mat-dialog-actions>